import { render, staticRenderFns } from "./wordLookupModal.vue?vue&type=template&id=7348eeb4&scoped=true&"
import script from "./wordLookupModal.vue?vue&type=script&lang=js&"
export * from "./wordLookupModal.vue?vue&type=script&lang=js&"
import style0 from "./wordLookupModal.vue?vue&type=style&index=0&id=7348eeb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348eeb4",
  null
  
)

export default component.exports